import React from 'react';

import './styles.css';

import DepositSummaryStatus from 'components/DepositSummaryStatus';

import {humanReadableBoolean} from 'utils/common';

interface DepositSummaryProps {
  depositPaid: boolean;
  depositBalance: number;
  depositPaidBalance: number;
  status: string;
}

interface DepositSummaryBasicInformationProps {
  depositSummary: DepositSummaryProps;
}

class DepositSummaryBasicInformation extends React.Component<
  DepositSummaryBasicInformationProps
> {
  render() {
    const {depositSummary} = this.props;

    return (
      <div className="DepositSummaryBasicInformation colab-row-space-between colab-centered-v colab-sidepadding-2">
        <div className="colab-centered-v">
          <div className="DepositSummaryBasicInformation__headerSection colab-row-space-between">
            <div className="DepositSummaryBasicInformation__headerSection--label colab-bold">
              Deposit paid
            </div>
            <div className="DepositSummaryBasicInformation__headerSection--value">
              {humanReadableBoolean(depositSummary.depositPaid)}
            </div>
          </div>
          <div className="DepositSummaryBasicInformation__headerSection colab-row-space-between">
            <div className="DepositSummaryBasicInformation__headerSection--label colab-bold">
              Deposit balance
            </div>
            <div className="DepositSummaryBasicInformation__headerSection--value">
              {depositSummary.depositBalance}
            </div>
          </div>
          <div className="DepositSummaryBasicInformation__headerSection colab-row-space-between">
            <div className="DepositSummaryBasicInformation__headerSection--label colab-bold">
              Deposit paid balance
            </div>
            <div className="DepositSummaryBasicInformation__headerSection--value">
              {depositSummary.depositPaidBalance}
            </div>
          </div>
        </div>
        <DepositSummaryStatus status={depositSummary.status} />
      </div>
    );
  }
}

export default DepositSummaryBasicInformation;
